import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface RequestProductsReport {
	responseTime: {
		averageMinutes: number | null;
		count: number;
		days: Array<{ date: string; averageMinutes: number | null; count: number }>;
	};
	pendingByMonth: {
		year: number;
		months: Array<{ month: number; count: number }>;
	};
	requestsByYear: Array<{ year: number; count: number }>;
}

export const useGetRequestProductsReport = (enabled = true) => {
	return useQuery({
		queryKey: ['request-products', 'report'],
		enabled,
		queryFn: async (): Promise<RequestProductsReport> => {
			const { data } = await api.get<RequestProductsReport>('/request-products/report');
			return data;
		},
	});
};
